/**
 * Catálogo en español.
 *
 * Es el idioma de referencia: `en.ts` debe tener exactamente estas claves, y
 * un test lo comprueba. Las claves se agrupan por pantalla y se nombran por lo
 * que significan, no por lo que dicen — así cambiar un texto no obliga a
 * renombrar nada.
 */
export const es = {
  'common.appName': '29100 Cloud',
  'common.tagline': 'Guardado para 29100.',
  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'common.loadMore': 'Cargar más',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar cambios',
  'common.delete': 'Eliminar',
  'common.download': 'Descargar',
  'common.share': 'Compartir',
  'common.open': 'Abrir',
  'common.rename': 'Renombrar',
  'common.edit': 'Editar',
  'cleanup.title': 'Qué puedes limpiar',
  'cleanup.body':
    'Lo que ocupa espacio y probablemente ya no necesitas. Aquí sólo se propone: borrar lo decides tú, y va a la papelera.',
  'cleanup.empty': 'No hay nada que proponer.',
  'cleanup.emptyBody': 'Ni duplicados, ni archivos grandes sin abrir. Tu espacio está limpio.',
  'cleanup.reclaimable': 'Espacio que recuperarías',
  'cleanup.reclaimableHint':
    'Es espacio de tu cuota. Los duplicados comparten el archivo guardado, así que borrar la copia te libera cuota a ti.',
  'cleanup.listHint': 'De lo que más ocupa a lo que menos.',
  'cleanup.reason.duplicate': 'Duplicado',
  'cleanup.reason.stale': 'Sin abrir',
  'cleanup.reason.large': 'Grande',
  'cleanup.copies': '{count, plural, one {1 copia igual} other {{count} copias iguales}}',
  'cleanup.lastOpened': 'Abierto por última vez el {date}',
  'cleanup.moveToTrash': 'A la papelera',
  'cleanup.moved': '{name} está en la papelera.',
  'cleanup.confirmTitle': 'Mover a la papelera',
  'cleanup.confirmBody': '{name} irá a la papelera. Podrás restaurarlo desde allí.',
  'nav.cleanup': 'Limpieza',
  'reviews.setDate': 'Fecha de revisión',
  'reviews.title': 'Qué toca revisar',
  'reviews.body':
    'Fechas de revisión de tus carpetas: vencimiento de pólizas, renovación de contratos, caducidad de certificados. Avisamos con antelación.',
  'reviews.empty': 'Ninguna carpeta tiene fecha de revisión.',
  'reviews.emptyBody':
    'Ponla desde la carpeta. Tu profesión propone la periodicidad; tú la cambias.',
  'reviews.overdueCount': 'ya vencieron y siguen sin revisar.',
  'reviews.overdueBy': '{days, plural, one {Venció hace 1 día} other {Venció hace {days} días}}',
  'reviews.inDays': '{days, plural, =0 {Vence hoy} one {En 1 día} other {En {days} días}}',
  'reviews.markDone': 'Ya revisada',
  'reviews.completed': 'Revisión hecha. No hay siguiente.',
  'reviews.completedNext': 'Revisión hecha. La siguiente, el {date}.',
  'reviews.saved': 'Fecha de revisión guardada.',
  'reviews.cleared': 'Esta carpeta ya no se revisa.',
  'reviews.clear': 'Quitar la fecha',
  'reviews.dialogTitle': 'Revisión de {name}',
  'reviews.dialogBody': 'Cuándo toca revisar esta carpeta y cada cuánto se repite.',
  'reviews.dueOn': 'Fecha de revisión',
  'reviews.recurrence': 'Se repite',
  'reviews.recurrence.NONE': 'Una sola vez',
  'reviews.recurrence.MONTHLY': 'Cada mes',
  'reviews.recurrence.QUARTERLY': 'Cada trimestre',
  'reviews.recurrence.SEMIANNUAL': 'Cada seis meses',
  'reviews.recurrence.ANNUAL': 'Cada año',
  'reviews.noticeDays': 'Avisar con estos días de antelación',
  'reviews.note': 'Qué hay que revisar',
  'reviews.notePlaceholder': 'Renovar la póliza de responsabilidad civil',
  'reviews.disclaimer':
    'Es un recordatorio, no una garantía: nada se bloquea si una fecha vence. Revisa siempre los plazos que te obliguen.',
  'nav.reviews': 'Revisiones',
  'archive.menu': 'Archivo permanente',
  'archive.dialogTitle': 'Archivo permanente: {name}',
  'archive.dialogBody':
    'Guarda esta carpeta y todo lo que hay dentro en almacenamiento de archivo: cuesta un tercio menos al mes, pero cada lectura se cobra aparte.',
  'archive.alreadyCold':
    'Esta carpeta ya está marcada como archivo permanente, igual que las que hay dentro.',
  'archive.filesInside': 'Archivos dentro',
  'archive.sizeInside': 'Ocupan',
  'archive.alreadyMoved': 'Ya movidos',
  'archive.movedCount': '{moved} de {total}',
  'archive.savings': 'Como mucho, ahorras {amount} al año si no se abren nunca.',
  'archive.breakeven':
    'A partir de {reads} lecturas al año sale más caro que el almacenamiento normal.',
  'archive.zipWarning':
    'Ojo: descargar la carpeta entera en ZIP lee todos los archivos de golpe y cuenta como una lectura de cada uno.',
  'archive.disclaimer':
    'No se mueve nada ahora. El mantenimiento nocturno traslada lo que lleve tiempo sin abrirse; los archivos siguen disponibles igual y desmarcar no cuesta nada.',
  'archive.mark': 'Marcar como archivo',
  'archive.unmark': 'Volver a normal',
  'archive.marked':
    '{folders, plural, one {La carpeta queda marcada como archivo permanente.} other {{folders} carpetas quedan marcadas como archivo permanente.}}',
  'archive.unmarked':
    '{folders, plural, one {La carpeta vuelve al almacenamiento normal.} other {{folders} carpetas vuelven al almacenamiento normal.}}',
  'common.favorite': 'Favorito',
  'common.close': 'Cerrar',
  'common.done': 'Listo',
  'common.copy': 'Copiar',
  'common.back': 'Volver',
  'common.comingSoon': 'Próximamente',
  'common.language': 'Idioma',
  'common.error': 'Algo salió mal',
  'common.confirm': 'Confirmar',
  'common.current': 'Actual',
  'common.dismiss': 'Descartar',
  'common.actions': 'Acciones',
  'common.create': 'Crear',

  'nav.dashboard': 'Inicio',
  'nav.files': 'Mis archivos',
  // Los cortos son sólo para la barra inferior del móvil, donde cada columna
  // mide 78 px. Ver `corto` en `lib/navigation.ts`.
  'nav.filesShort': 'Archivos',
  'nav.photos': 'Fotos',
  'nav.albums': 'Álbumes',
  'nav.checklists': 'Listas',
  'nav.requests': 'Solicitudes',
  'nav.sharedLinks': 'Enlaces compartidos',
  'nav.sharedLinksShort': 'Enlaces',
  'nav.favorites': 'Favoritos',
  'nav.trash': 'Papelera',
  'nav.activity': 'Actividad',
  'nav.settings': 'Ajustes',
  'nav.team': 'Equipo',
  'nav.sharedFolders': 'Carpetas compartidas',
  'nav.sharedFoldersShort': 'Carpetas',
  'nav.reports': 'Informes',
  'nav.pricing': 'Precios',
  'nav.legal': 'Legal',
  'nav.terms': 'Términos',
  'nav.privacy': 'Privacidad',
  'nav.acceptableUse': 'Uso aceptable',
  'nav.contact': 'Contacto',
  'nav.signIn': 'Entrar',
  'nav.signOut': 'Cerrar sesión',
  'nav.getStarted': 'Empezar',
  'nav.search': 'Buscar archivos y carpetas…',
  'nav.searching': 'Buscando…',
  'nav.noMatches': 'Sin resultados.',
  'nav.notifications': 'Notificaciones',
  'nav.account': 'Mi cuenta',
  'nav.platformAdmin': 'Panel de plataforma',
  'nav.skipToContent': 'Saltar al contenido',
  'nav.openMenu': 'Abrir menú',
  'nav.closeMenu': 'Cerrar menú',
  'nav.sections': 'Secciones',
  'nav.main': 'Navegación principal',

  /*
   * Grupos del menú.
   *
   * Las cabeceras nombran la pregunta que responde el grupo, no la tecnología:
   * quien busca un enlace que compartió no piensa «módulo de compartición»,
   * piensa «¿qué he compartido?».
   */
  'nav.group.library': 'Mi contenido',
  'nav.group.libraryBody': 'Tus fotos, álbumes y las listas que sigues.',
  'nav.group.sharing': 'Compartido',
  'nav.group.sharingBody':
    'Lo que has abierto a otras personas y lo que otras te han abierto a ti.',
  'nav.group.organization': 'Organización',
  'nav.group.organizationBody': 'El equipo, sus plazos y lo que ha pasado en el espacio.',
  /*
   * «Almacenamiento» y no «Espacio»: en este producto un espacio es un
   * workspace —el selector de la barra lateral dice «Mi espacio»— y usar la
   * misma palabra para el sitio que ocupan los archivos deja al usuario con dos
   * significados y ninguna pista de cuál toca.
   */
  'nav.group.space': 'Almacenamiento',
  'nav.group.spaceBody': 'Lo que ocupa sitio sin hacer falta y lo que ya has borrado.',
  'nav.expandGroup': 'Mostrar {section}',
  'nav.collapseGroup': 'Ocultar {section}',
  'nav.openSection': 'Abrir',

  'navHint.sharedFolders': 'Carpetas que otras personas de la organización te han dado.',
  'navHint.sharedLinks': 'Los enlaces que has creado, con sus descargas y su caducidad.',
  'navHint.requests': 'Pide documentos a alguien aunque no tenga cuenta.',
  'navHint.cleanup': 'Duplicados, archivos grandes y lo que llevas meses sin abrir.',
  'navHint.trash': 'Lo borrado sigue aquí hasta que se purga: se puede restaurar.',

  /*
   * Portada.
   *
   * El encabezado dejó de ser un eslogan para ser una oferta. «Tus archivos.
   * Tu espacio. Tu control.» describe lo mismo que Drive, Dropbox y OneDrive,
   * y contra ellos esa pelea está perdida de antemano: `docs/product-strategy.md`
   * dice, con las cuentas hechas, que vender gigabytes es un mal negocio y
   * vender el trabajo resuelto es uno bueno. La portada vendía lo primero.
   */
  'landing.heroBadge': 'Se adapta a {count} profesiones',
  'landing.heroTitle': 'La nube que ya sabe cómo trabaja tu profesión.',
  'landing.heroSubtitle':
    'Dinos a qué te dedicas y tu espacio nace ordenado: las carpetas, los nombres y las listas de tu oficio, montadas antes de que subas el primer archivo.',
  'landing.heroNote': 'Plan gratuito para siempre. Sin tarjeta.',
  'landing.startFree': 'Empezar gratis',

  'landing.profilesTitle': 'Tu espacio no empieza vacío',
  'landing.profilesBody':
    'Al crear la cuenta preguntamos a qué se va a dedicar. Con esa única respuesta cambia el vocabulario, la estructura de carpetas y lo que la plataforma te recuerda: un despacho no guarda «archivos en carpetas», guarda documentos en expedientes.',
  'landing.profilesMore': 'Y {count} perfiles más, repartidos en estas categorías:',

  'landing.doTitle': 'Tres cosas que tu nube de ahora no hace',
  'landing.doIntakeTitle': 'Pídele documentos a quien no tiene cuenta',
  'landing.doIntakeBody':
    'Le mandas un enlace, ve exactamente qué le pides —una casilla por documento— y lo entrega sin registrarse en nada. Tú ves el avance mientras llega.',
  'landing.doChecklistTitle': 'Sabe qué papeles faltan',
  'landing.doChecklistBody':
    'Cada trámite de tu profesión trae su lista de verificación. Lo que falta se ve de un vistazo, en lugar de descubrirse el día de la entrega.',
  'landing.doExportTitle': 'Te puedes ir cuando quieras',
  'landing.doExportBody':
    'Descargas el inventario completo de tu cuenta y programas su eliminación tú mismo, desde Ajustes. Sin escribir a soporte y sin dar explicaciones.',

  'landing.pricingTitle': 'Empieza gratis y paga sólo si te sirve',
  'landing.pricingBody':
    'El plan gratuito no caduca y no pide tarjeta. Los de pago se contratan cuando el espacio se te queda corto, y se cancelan desde la propia aplicación.',
  'landing.pricingFrom': 'Planes de pago desde {price} al mes',
  'landing.seePlans': 'Ver todos los planes',
  'landing.explorePlans': 'Ver planes',
  'landing.goToDashboard': 'Ir a mi cuenta',
  'landing.openYourSpace': 'Abrir mi espacio',
  'landing.startPersonal': 'Empezar con Personal',
  'landing.exploreBusiness': 'Conocer Business',
  'landing.personalTitle': '29100 Cloud Personal',
  'landing.personalBody':
    'Para personas y familias que quieren sus recuerdos y documentos en un solo sitio seguro.',
  'landing.businessTitle': '29100 Cloud Business',
  'landing.businessBody':
    'Para profesionales y equipos: carpetas compartidas, roles, permisos y registro de actividad.',
  'landing.pillarSecurity': 'Seguridad',
  'landing.pillarSecurityBody':
    'Almacenamiento privado, enlaces firmados de vida corta y sesiones protegidas.',
  'landing.pillarSimplicity': 'Sencillez',
  'landing.pillarSimplicityBody': 'Sube, organiza y comparte sin leer un manual.',
  'landing.pillarControl': 'Control',
  'landing.pillarControlBody': 'Tú decides quién ve qué, durante cuánto tiempo y cuántas veces.',

  /*
   * Franja de confianza.
   *
   * Ninguna de estas cuatro frases es un eslogan: cada una describe algo que
   * el código hace y que se puede comprobar —HSTS de un año, TOTP, el HMAC de
   * la IP, el cobro fuera de la plataforma y la exportación desde Ajustes—.
   * Si alguna deja de ser cierta, hay que quitarla de aquí antes que del
   * backend.
   */
  'trust.title': 'Lo que hacemos para que puedas confiar',
  'trust.encryptionTitle': 'Conexión siempre cifrada',
  'trust.encryptionBody': 'HTTPS obligatorio, sin excepciones y sin vuelta atrás.',
  'trust.mfaTitle': 'Verificación en dos pasos',
  'trust.mfaBody': 'Con la aplicación de autenticación que ya usas.',
  'trust.privacyTitle': 'No guardamos tu IP',
  'trust.privacyBody': 'Ni tus datos de tarjeta: el pago ocurre fuera.',
  'trust.exportTitle': 'Exporta todo y vete',
  'trust.exportBody': 'Tú solo, desde Ajustes, sin pedirle permiso a nadie.',
  /*
   * De quién son las certificaciones.
   *
   * Lo único que sostiene esta frase es la concordancia: «certificados» va con
   * Cloudflare y Neon, no con nosotros. 29100 Cloud no está certificado por
   * nadie, así que cualquier reescritura que ponga la norma al lado del
   * producto —«29100 Cloud, certificado ISO 27001», o un sello en la
   * portada— pasa de ser un matiz a ser publicidad engañosa, y es lo primero
   * que un cliente empresa comprueba.
   */
  'trust.infraNote': 'Funcionamos sobre Cloudflare y Neon, certificados ISO 27001 y SOC 2 Tipo II.',

  'contact.title': 'Contacto',
  'contact.lead':
    'Estamos ultimando los canales de atención de 29100 Cloud. En cuanto estén activos publicaremos aquí toda la información: dirección de soporte, formulario de contacto y horario de atención.',
  'contact.nextTitle': 'Qué encontrarás aquí muy pronto',
  'contact.nextSupport': 'Correo de soporte',
  'contact.nextSupportBody':
    'Una dirección atendida por el equipo que opera la plataforma, con seguimiento de cada solicitud.',
  'contact.nextForm': 'Formulario de contacto',
  'contact.nextFormBody':
    'Para escribirnos sin salir de la web, con el asunto ya clasificado para que llegue a quien corresponde.',
  'contact.nextHours': 'Horario y tiempos de respuesta',
  'contact.nextHoursBody':
    'La franja de atención y el plazo de respuesta, para que sepas cuándo esperar contestación.',
  'contact.statusTitle': 'Mientras tanto',
  'contact.statusBody':
    'La plataforma está en su fase final de puesta en marcha y estará plenamente operativa en breve. Si necesitas contactar antes, escribe a la dirección publicada por el operador del servicio: atenderemos igualmente tu mensaje.',
  'contact.note': 'Actualizaremos esta página en cuanto los canales estén disponibles.',

  'terms.title': 'Términos del Servicio',
  'terms.badge': 'Borrador',
  'terms.updated': 'Última actualización: {date}',
  'terms.provisional':
    'Versión provisional, pendiente de revisión legal antes de la apertura comercial. Describe con exactitud cómo funciona hoy la plataforma; el texto definitivo se publicará en esta misma página.',
  'terms.lead':
    'Estos términos regulan el uso de 29100 Cloud. Al crear una cuenta los aceptas; si no estás de acuerdo con alguno de ellos, no uses el servicio.',
  'terms.operatorTitle': 'Quién presta el servicio',
  'terms.operatorBody':
    '29100 Cloud es un servicio de almacenamiento y compartición de archivos operado desde Ecuador y ofrecido en Ecuador y el resto de Latinoamérica. La razón social, el RUC y el domicilio del prestador se publicarán en esta sección antes de la apertura comercial; hasta entonces, el canal de contacto es el indicado en la página de Contacto.',
  'terms.accountTitle': 'La cuenta',
  'terms.accountBody':
    'Para usar el servicio necesitas una cuenta con un correo electrónico válido. Eres responsable de mantener tu contraseña en secreto y de lo que ocurra bajo tu sesión; puedes activar la verificación en dos pasos desde Ajustes. Debes ser mayor de edad o contar con autorización de tu representante legal, y los datos que declares al registrarte deben ser ciertos.',
  'terms.plansTitle': 'Planes, cuotas y plan gratuito',
  'terms.plansBody':
    'Toda cuenta nueva empieza en el plan gratuito de su línea —Personal o Business—, sin periodo de prueba y sin cobro. Cada plan define una cuota de espacio, un tamaño máximo de archivo y un número de espacios; el detalle está en la página de Precios y en Ajustes → Suscripción. Cambiar de plan siempre parte de una solicitud tuya: nadie te cobra una mejora que no hayas pedido. Si rebajas de plan y superas la cuota nueva, dispones de {quotaGraceDays} días para liberar espacio antes de que el exceso pase a la papelera.',
  'terms.paymentTitle': 'Pago, renovación e impago',
  'terms.paymentBody':
    'El cobro es manual: recibes un enlace de pago de un proveedor externo y el plan se activa cuando el pago queda confirmado. No guardamos datos de tarjeta —ninguno pasa por la plataforma—. El vencimiento se avisa con antelación y, cumplido el periodo, hay {expiryGraceDays} días de cortesía. Si el pago no llega, el espacio pasa a sólo lectura a los {suspendDays} días, deja de ser accesible a los {blockDays} y se borra de forma definitiva a los {deleteDays}. Cada paso se avisa antes de darse y afecta al espacio impagado, no a tu cuenta ni a tus demás espacios: exporta o descarga lo que necesites antes del bloqueo, porque después ya no podrás entrar.',
  'terms.withdrawalTitle': 'Derecho de devolución',
  'terms.withdrawalBody':
    'Si contratas como consumidor final, puedes ejercer el derecho de devolución que la Ley Orgánica de Defensa del Consumidor reconoce a quien contrata por medios electrónicos, dentro del plazo legal y a través del canal de Contacto. Cancelar un plan de pago nunca requiere llamar ni escribir: se hace desde Ajustes, en los mismos pasos en que se contrató.',
  'terms.contentTitle': 'Tus archivos y tu contenido',
  'terms.contentPromise':
    'Los archivos que subes son tuyos. No los usamos para nada distinto de prestarte el servicio, no los cedemos a terceros, no los analizamos con fines comerciales o publicitarios y no entrenamos modelos con ellos.',
  'terms.contentBody':
    'Nos autorizas únicamente a almacenarlos, transmitirlos y procesarlos en la medida necesaria para que el servicio funcione: guardarlos, mostrarte una vista previa, generar una miniatura, comprimir una carpeta que pediste descargar o entregarlos a quien tú decidas compartir. Eres responsable de tener los derechos sobre lo que subes. Puedes descargar tus archivos y exportar tu inventario en cualquier momento desde Ajustes → Privacidad.',
  'terms.useTitle': 'Uso aceptable',
  'terms.useBody':
    'No puedes usar 29100 Cloud para almacenar o distribuir contenido ilícito, ni material sobre el que no tengas derechos, ni para comprometer la seguridad de la plataforma o de terceros. El detalle está en la página de Uso aceptable. Ante un incumplimiento grave o una orden de autoridad competente podemos suspender el espacio afectado; salvo que la ley lo impida, te comunicaremos el motivo.',
  'terms.sharingTitle': 'Compartir y enlaces públicos',
  'terms.sharingBody':
    'Un enlace compartido lo creas tú y lo gobiernas tú: puedes protegerlo con contraseña, ponerle fecha de caducidad y un número máximo de descargas, y revocarlo cuando quieras. Mientras esté activo, quien tenga el enlace accede a lo compartido, así que compartir es tu decisión y tu responsabilidad. En Business puedes además restringir una carpeta a personas concretas del equipo.',
  'terms.availabilityTitle': 'Disponibilidad y copias',
  'terms.availabilityBody':
    'Trabajamos para que el servicio esté disponible de forma continua, pero no comprometemos un porcentaje de disponibilidad ni un tiempo de respuesta mientras no exista un acuerdo de nivel de servicio firmado. Puede haber interrupciones por mantenimiento, por fallo de un proveedor de infraestructura o por causas ajenas a nuestro control. La papelera conserva lo que borras durante el plazo que fije tu plan y desde ahí puedes restaurarlo, pero eso no sustituye a una copia de seguridad propia: mantenla para lo que sea crítico.',
  'terms.dataTitle': 'Protección de datos',
  'terms.dataBody':
    'Tratamos tus datos personales conforme a la Ley Orgánica de Protección de Datos Personales del Ecuador. Qué datos guardamos, con qué finalidad y durante cuánto tiempo se detalla en la Política de Privacidad. No conservamos direcciones IP en claro. La infraestructura de almacenamiento y base de datos es de proveedores internacionales, de modo que tus datos pueden alojarse fuera del Ecuador con las garantías que exige la norma. Los derechos de acceso, portabilidad y supresión se ejercen desde Ajustes → Privacidad, sin escribir a nadie.',
  'terms.terminationTitle': 'Baja, cancelación y borrado',
  'terms.terminationBody':
    'Puedes cancelar la suscripción cuando quieras desde Ajustes: cancelar no cierra tu cuenta, baja al plan gratuito y conservas el acceso. Cerrar la cuenta se solicita también desde Ajustes y se ejecuta a los {accountDeletionDays} días; durante ese plazo la cuenta funciona con normalidad y puedes anular la baja. Al vencer se borran tus archivos y se anonimiza tu perfil. Los registros de facturación se conservan sin vínculo contigo, por obligación contable.',
  'terms.liabilityTitle': 'Responsabilidad',
  'terms.liabilityBody':
    'Prestamos el servicio con la diligencia debida, pero no respondemos de la pérdida de datos que provenga de tu propio borrado, de la pérdida de tus credenciales, del uso que terceros hagan de un enlace que tú compartiste o del fallo de un proveedor externo de infraestructura. Salvo dolo o culpa grave, y en la medida en que la ley permita limitarla, nuestra responsabilidad se limita al importe que hayas pagado por el servicio en los doce meses anteriores al hecho. Nada de esto recorta los derechos que la ley reconoce a los consumidores.',
  'terms.changesTitle': 'Cambios en los términos',
  'terms.changesBody':
    'Podemos actualizar estos términos. Un cambio relevante se avisa con antelación razonable dentro de la aplicación y queda reflejado en la fecha de actualización de esta página. Si un cambio no te conviene, puedes cancelar o darte de baja antes de que entre en vigor.',
  'terms.lawTitle': 'Ley aplicable',
  'terms.lawBody':
    'Estos términos se rigen por las leyes de la República del Ecuador y cualquier controversia se somete a sus jueces competentes. Si contratas como consumidor final desde otro país de Latinoamérica, esto no te priva de los derechos ni del fuero que te reconozca la ley de tu lugar de residencia.',
  'terms.contactNote': '¿Alguna duda sobre estos términos? Escríbenos desde la página de Contacto.',

  'auth.signInTitle': 'Entrar en 29100 Cloud',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.signingIn': 'Entrando…',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.createOne': 'Crear una',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.signInFailed': 'No se pudo iniciar sesión',
  'auth.captchaPending': 'Completa la verificación de seguridad para continuar.',
  'auth.captchaFailed':
    'No se pudo cargar la verificación de seguridad. Revisa tu conexión y recarga la página.',
  // El acceso fue bien y aun así no hay sesión: la cookie la descartó el
  // navegador, no el servidor. Se nombra la causa real y qué hacer, porque el
  // mensaje genérico manda a revisar la contraseña, que es lo único correcto.
  'auth.sessionNotStored':
    'Tus credenciales son correctas, pero el navegador no ha guardado la sesión. Suele pasar cuando bloquea las cookies de terceros: prueba en una ventana normal (no privada) o permite las cookies para este sitio.',

  'dashboard.welcome': 'Hola de nuevo, {name}',
  'dashboard.uploadFiles': 'Subir archivos',
  'dashboard.newFolder': 'Nueva carpeta',
  'dashboard.createLink': 'Crear enlace',
  'dashboard.totalStorage': 'Almacenamiento',
  'dashboard.files': 'Archivos',
  'dashboard.sharedLinks': 'Enlaces',
  'dashboard.photos': 'Fotos',
  'dashboard.viewAll': 'Ver todo',
  'dashboard.businessTitle': 'Espacio de empresa',
  'dashboard.businessBody': 'Equipo, carpetas compartidas y permisos.',
  'dashboard.businessAction': 'Ir al equipo',
  'dashboard.personalTitle': 'Espacio personal',
  'dashboard.personalBody': 'Tus fotos, tus álbumes y lo que marcaste como favorito.',
  'dashboard.personalAction': 'Ver mis fotos',

  'dashboard.storageBody': 'Lo que ocupa este espacio ahora mismo.',
  'dashboard.favoritesBody': 'Los archivos que marcaste para encontrarlos rápido.',

  /*
   * Primeros pasos.
   *
   * Sólo aparece con el espacio vacío, que es cuando un panel lleno de ceros
   * no dice nada y el cliente no sabe por dónde empezar. En cuanto hay un
   * archivo desaparece solo: un tutorial que no se va acaba siendo ruido.
   */
  'dashboard.startTitle': 'Tu espacio está vacío. Empecemos.',
  'dashboard.startBody': 'Tres pasos y ya lo tienes funcionando.',
  'dashboard.startUpload': 'Sube tus archivos',
  'dashboard.startUploadBody': 'Arrástralos sobre la ventana o elígelos del equipo.',
  'dashboard.startOrganize': 'Ordénalos en carpetas',
  'dashboard.startOrganizeBody': 'Por cliente, por proyecto o como tú trabajes.',
  'dashboard.startShare': 'Comparte lo que decidas',
  'dashboard.startShareBody': 'Con contraseña, con caducidad y con límite de descargas.',
  // --- La aplicación de móvil (fase 19) --------------------------------------
  //
  // Un solo camino por aparato: el APK en Android, la aplicación web en iOS
  // mientras no haya ficha en App Store, y el código QR en un ordenador.
  'mobile.title': 'La aplicación en tu teléfono',
  'mobile.body': 'Sube fotos y documentos desde donde estés, sin abrir el ordenador.',
  'mobile.locked': 'Tu plan no incluye la aplicación de móvil.',
  'mobile.lockedWithPlan': 'La aplicación de móvil viene desde {plan}, por {price} al mes.',
  'mobile.upgrade': 'Cambiar de plan',
  'mobile.alreadyInstalled': 'Ya la tienes instalada: estás usándola ahora mismo.',
  'mobile.androidDownload': 'Descargar para Android',
  'mobile.androidMeta': 'Versión {version} · {size}',
  'mobile.androidWarnUnknownSources':
    'Al instalarla, Android pedirá permiso para instalar desde esta fuente. Es normal: la aplicación no viene de Play Store.',
  'mobile.androidWarnUpdates':
    'No se actualiza sola. La aplicación te avisará cuando haya una versión nueva.',
  'mobile.androidSoon': 'La aplicación de Android está en preparación. Te avisaremos aquí mismo.',
  'mobile.androidWebApp':
    'Mientras tanto, puedes instalar esta web como aplicación desde el menú de Chrome: «Instalar aplicación».',
  'mobile.iosAppStore': 'Ver en App Store',
  'mobile.iosIntro':
    'En iPhone y iPad se instala desde Safari, en tres pasos. Queda con su icono en la pantalla de inicio y se abre a pantalla completa.',
  'mobile.iosStep1': 'Toca el botón de compartir, abajo en el centro.',
  'mobile.iosStep2': 'Baja y elige «Añadir a pantalla de inicio».',
  'mobile.iosStep3': 'Confirma con «Añadir», arriba a la derecha.',
  'mobile.iosOpenInSafari':
    'Abre esta página en Safari para poder instalarla: los demás navegadores de iPhone no tienen esa opción.',
  'mobile.iosNote': 'Estamos preparando la ficha de App Store. Hasta entonces, éste es el camino.',
  'mobile.qrLabel': 'Código QR con la dirección del panel',
  'mobile.desktopBody': 'Escanea el código con la cámara del teléfono para abrir el panel ahí.',
  'mobile.desktopHint': 'Desde el teléfono verás cómo instalarla, según sea Android o iPhone.',

  'storage.used': 'Espacio usado',
  'storage.remaining': '{amount} disponibles',
  'storage.full': 'Espacio agotado',
  'storage.upgrade': 'Mejorar plan',

  'files.title': 'Mis archivos',
  'files.home': 'Inicio',
  'files.empty': 'Tu nube está vacía.',
  'files.emptyBody': 'Sube tu primer archivo para empezar.',
  'files.uploadFirst': 'Subir mi primer archivo',
  'files.listView': 'Vista de lista',
  'files.gridView': 'Vista de cuadrícula',
  'files.moveToTrash': '¿Mover a la papelera?',
  'files.moveToTrashBody': '{name} irá a la papelera. Podrás restaurarlo desde allí.',
  'files.count': '{count, plural, =0 {Sin archivos} one {1 archivo} other {{count} archivos}}',
  'files.downloadZip': 'Descargar en ZIP',

  'photos.title': 'Fotos',
  'photos.empty': 'Aún no hay nada aquí.',
  'photos.emptyBody': 'Sube fotos y vídeos y aparecerán aquí automáticamente.',
  'photos.albums': 'Álbumes',
  'photos.selected': '{count, plural, one {1 seleccionado} other {{count} seleccionados}}',

  'favorites.title': 'Favoritos',
  'favorites.empty': 'Aún no tienes favoritos.',
  'favorites.emptyBody': 'Marca un archivo como favorito y aparecerá aquí.',
  'favorites.remove': 'Quitar',

  'trash.title': 'Papelera',
  'trash.empty': 'Tu papelera está vacía.',
  'trash.retention':
    'Los elementos se borran definitivamente {days, plural, one {1 día} other {{days} días}} después de llegar aquí.',
  'trash.restore': 'Restaurar',
  'trash.deleteForever': 'Borrar definitivamente',
  'trash.confirmTitle': '¿Borrar definitivamente?',
  'trash.confirmBody':
    '{name} se borrará del almacenamiento y no se podrá recuperar. También libera el espacio que ocupa.',

  'shares.title': 'Enlaces compartidos',
  'shares.subtitle': 'Todos los enlaces que has creado y cómo se están usando.',
  'shares.copyWarning':
    'Los enlaces sólo se pueden copiar al crearlos: guardamos un hash del token, no el token. Crea uno nuevo si perdiste la URL.',
  'shares.empty': 'Todavía no has compartido nada.',
  'shares.emptyBody': 'Crea un enlace desde cualquier archivo para compartirlo.',
  'shares.file': 'Archivo',
  'shares.folder': 'Carpeta',
  'shares.created': 'Creado',
  'shares.expiration': 'Caducidad',
  'shares.never': 'Nunca',
  'shares.downloads': 'Descargas',
  'shares.status': 'Estado',
  'shares.disable': 'Desactivar',
  'shares.linkCopied': 'Enlace copiado',
  'shares.shareFile': 'Compartir archivo',
  'shares.passwordOptional': 'Contraseña (opcional)',
  'shares.passwordHint': 'Déjalo vacío para que cualquiera con el enlace pueda abrirlo.',
  'shares.permissions': 'Permisos',
  'shares.preview': 'Vista previa',
  'shares.createLink': 'Crear enlace',
  'shares.createdBody':
    'Cualquiera con este enlace puede abrir el archivo. Cópialo ahora: guardamos sólo un hash del token, así que esta URL no se puede volver a mostrar.',

  'activity.title': 'Actividad',
  'activity.empty': 'Aún no hay actividad.',
  'activity.upgradeTitle': 'Mejora tu plan para usar esta función',
  'activity.upgradeBody':
    'El historial de actividad está disponible en los planes Plus y Business.',
  'activity.viewPlans': 'Ver planes',

  'settings.title': 'Ajustes',
  'settings.profile': 'Perfil',
  'settings.security': 'Seguridad',
  'settings.storage': 'Almacenamiento',
  'settings.subscription': 'Suscripción',
  'settings.firstName': 'Nombre',
  'settings.lastName': 'Apellidos',
  'settings.emailVerified': 'Verificado.',
  'settings.emailUnverified': 'Sin verificar',
  'settings.profileBody': 'Cómo apareces en 29100 Cloud.',
  'settings.emailVerifyPending':
    'Sin verificar todavía. Cambiar el correo exige verificarlo, y para eso hace falta un proveedor de correo configurado.',
  'settings.changePasswordBody': 'Cierra todas las demás sesiones abiertas.',
  'settings.sessionsBody': 'Dónde tienes la sesión abierta ahora mismo.',
  'settings.passwordChangeFailed': 'No se pudo cambiar la contraseña',
  'common.loadingPlan': 'Cargando plan…',
  'settings.profileUpdated': 'Perfil actualizado',
  'settings.changePassword': 'Cambiar contraseña',
  'settings.currentPassword': 'Contraseña actual',
  'settings.newPassword': 'Contraseña nueva',
  'settings.activeSessions': 'Sesiones activas',
  'settings.thisDevice': 'Este dispositivo',
  'settings.logoutAll': 'Cerrar todas las sesiones',
  'settings.mfa': 'Verificación en dos pasos',
  'settings.currentPlan': 'Plan actual',
  'settings.changePlan': 'Cambiar de plan',
  'settings.languageHint': 'Se aplica a toda la aplicación y se recuerda en tus dispositivos.',

  'pricing.title': 'Planes que crecen contigo',
  'pricing.subtitle': 'Empieza gratis. Mejora cuando necesites más espacio.',
  'pricing.personal': 'Personal',
  'pricing.business': 'Business',
  'pricing.months': '{count, plural, one {1 mes} other {{count} meses}}',
  'pricing.termHint':
    '{free, plural, one {Un mes gratis por pagarlo por adelantado.} other {{free} meses gratis por pagarlo por adelantado.}}',
  'pricing.billedUpfront':
    '{count, plural, one {Se cobra {total} de una vez} other {Se cobra {total} de una vez por {count} meses}}',
  'pricing.billingPeriod': 'Periodo de facturación',
  'pricing.monthly': 'Mensual',
  'pricing.yearly': 'Anual',
  'pricing.yearlyHint': 'Pagando el año por adelantado son dos meses gratis.',
  'pricing.billedYearly': 'Se cobra {total} una vez al año',
  'pricing.currentPlan': 'Plan actual',
  'pricing.mostPopular': 'El más elegido',
  'pricing.perMonth': '/mes',
  'pricing.storage': 'Almacenamiento',
  'pricing.users': 'Usuarios',
  'pricing.maxFileSize': 'Tamaño máximo por archivo',
  'pricing.included': 'Incluido',
  'pricing.requestPlan': 'Solicitar plan',
  'pricing.requestSent': 'Solicitud enviada. Te haremos llegar el link de pago en breve.',
  'pricing.manualNote':
    'Los planes de pago se activan a mano: te enviamos un link de pago, pagas y activamos el plan al confirmar el ingreso. Verás cada paso en tu cuenta.',
  'pricing.loadFailed': 'No pudimos cargar los planes.',

  'upload.optimize': 'Encoger las fotos antes de subirlas',
  'upload.optimizeHint':
    'Sólo afecta a fotos JPEG y WebP grandes; se ven igual y ocupan mucho menos. No se toca ningún otro archivo.',
  'upload.optimizeSaved': 'Te has ahorrado {amount} de tu espacio.',
  'upload.title': 'Subir archivos',
  'upload.subtitle':
    'Los archivos van directos al almacenamiento; no pasan por nuestros servidores.',
  'upload.dropHere': 'Arrastra los archivos aquí',
  'upload.chooseFiles': 'Elegir archivos',
  'upload.clearCompleted': 'Limpiar completados',
  'upload.retryFailed':
    '{count, plural, one {Reintentar la que falló} other {Reintentar las {count} que fallaron}}',
  'upload.uploading': 'Subiendo…',
  'upload.statusQueued': 'En cola',
  'upload.statusUploading': 'Subiendo',
  'upload.statusProcessing': 'Procesando',
  'upload.statusCompleted': 'Completado',
  'upload.statusFailed': 'Falló',
  /*
   * Los dos fallos de red del navegador se cuentan por separado a propósito:
   * uno se arregla reintentando y el otro no se arregla nunca por ahí. Ver el
   * comentario de `useUpload.ts`.
   */
  'upload.errorNotStarted':
    'La subida no llegó a empezar. No es tu conexión: el almacenamiento no aceptó la petición. Si te pasa con todos los archivos, avísanos.',
  'upload.errorInterrupted': 'Se cortó la conexión a mitad de la subida. Vuelve a intentarlo.',
  'upload.errorRejected':
    'El almacenamiento rechazó el archivo (código {status}). Vuelve a intentarlo.',
  'upload.errorCancelled': 'Cancelada',
  'upload.errorGeneric': 'No se pudo subir',

  'error.notFound': 'Página no encontrada',
  'error.notFoundBody': 'La página que buscas no existe o se movió.',
  'error.forbidden': 'No tienes permiso',
  'error.forbiddenBody':
    'No tienes permiso para hacer esto. Pídeselo a un administrador de este espacio.',
  'error.serverError': 'Algo salió mal',
  'error.serverErrorBody': 'No pudimos completar la petición. Inténtalo de nuevo en un momento.',
  'error.goHome': 'Ir al inicio',

  // Traducción de los códigos estables que devuelve la API. La interfaz decide
  // por código y nunca por el texto, así que el backend no traduce nada.
  'auth.registerTitle': 'Crear tu cuenta',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellidos',
  'auth.creating': 'Creando cuenta…',
  'auth.createAccount': 'Crear cuenta',
  'auth.haveAccount': '¿Ya tienes cuenta?',
  'auth.registerFailed': 'No se pudo completar el registro',
  'auth.passwordHint': 'Mínimo 10 caracteres, con al menos una letra y un número.',
  'auth.accountType': '¿Qué cuenta quieres crear?',
  'auth.accountTypeHint': 'Puedes abrir la otra más adelante, sin volver a registrarte.',
  'auth.accountTypePersonal': '29100 Cloud Personal',
  'auth.accountTypeBusiness': '29100 Cloud Business',
  'auth.accountTypePersonalNote': 'Tu espacio personal, para ti y tu familia.',
  'auth.accountTypeBusinessNote':
    'Un espacio de empresa con su organización, equipo y carpetas compartidas.',
  'auth.organizationName': 'Nombre de la organización',
  'auth.organizationNameHint': 'El nombre con el que verán tu espacio quienes invites al equipo.',
  'auth.organizationNamePlaceholder': 'Estudio Jurídico Pérez',
  'auth.personalUseTitle': '¿Para qué vas a usar 29100 Cloud?',
  'auth.businessUseTitle': '¿A qué se dedica tu organización?',
  'auth.signInLink': 'Inicia sesión',
  'profile.allSectors': 'Todos',
  'profile.sector': 'Sector',
  'profile.searchLabel': 'Buscar perfil',
  'profile.searchPlaceholder': 'Busca tu profesión o sector…',
  'profile.groupLabel': 'Perfil de uso',
  'profile.noMatches':
    'No encontramos un perfil para «{query}». Puedes elegir uno general y ajustarlo después.',
  'profile.moreQuestions': 'Cuéntanos un poco más',
  'profile.selectPlaceholder': 'Selecciona…',
  'profile.templateTitle': 'Crearemos esta estructura de {folders}',
  'profile.tailoredHint':
    'Adaptamos las carpetas y las opciones a tu caso. Podrás cambiarlo después.',
  'onboarding.title': '¿Para qué vas a usar tu espacio?',
  'onboarding.subtitle': 'Adaptamos las carpetas, los nombres y las funciones a tu actividad.',
  'onboarding.continue': 'Continuar',
  'onboarding.creating': 'Creando espacio…',
  'onboarding.workspaceName': 'Nombre del espacio',
  'onboarding.failed': 'No se pudo crear el espacio',
  'onboarding.allowance': 'Espacios de empresa: {used} de {limit}.',
  'onboarding.allowanceRemaining': 'Puedes abrir {remaining} más con tu plan actual.',
  'onboarding.allowanceExhausted':
    'Tu plan ({plan}) permite {limit} espacio(s) de empresa y ya los tienes abiertos. Mejora el plan para abrir otro.',
  'onboarding.allowanceUpgrade': 'Ver planes',
  'files.uploadFiles': 'Subir archivos',
  'files.newFolder': 'Nueva carpeta',
  'files.folderName': 'Nombre de la carpeta',
  'files.folderCreated': 'Carpeta creada',
  'files.folderFailed': 'No se pudo crear la carpeta',
  'files.renamePrompt': 'Nombre nuevo',
  'files.renamed': 'Archivo renombrado',

  /*
   * Mover.
   *
   * La API sabía mover desde el primer día y no había ninguna puerta: un
   * documento que caía donde no debía —los que llegan por una solicitud los
   * coloca el servidor, no una persona— se quedaba allí para siempre.
   */
  'files.move': 'Mover',
  'files.moveTitle': 'Mover «{name}»',
  'files.moved': '«{name}» se movió.',

  'folders.destination': 'Carpeta de destino',
  'folders.destinationHint': 'Se puede elegir cualquier carpeta, esté al nivel que esté.',
  'folders.root': 'Raíz del espacio',
  'folders.pickOne': 'Elige una carpeta…',
  'folders.none': 'Todavía no hay carpetas',
  'files.renameFailed': 'No se pudo renombrar',
  'files.favorited': 'Añadido a favoritos',
  'files.favoriteFailed': 'No se pudo actualizar el favorito',
  'files.downloadFailed': 'No se pudo preparar la descarga',
  'files.movedToTrash': 'Movido a la papelera',
  'files.trashFailed': 'No se pudo eliminar el archivo',
  'files.actionsFor': 'Acciones para {name}',
  'files.breadcrumb': 'Ruta',
  'photos.uploadPhotos': 'Subir fotos',
  'photos.clearSelection': 'Quitar selección ({count})',
  'photos.deleted':
    '{count, plural, one {1 movido a la papelera} other {{count} movidos a la papelera}}',
  'photos.albumsPending': 'Vacaciones, Familia, Trabajo, Eventos — requiere {endpoint}.',
  'photos.select': 'Seleccionar {name}',
  'photos.loadMore': 'Cargar más',
  'photos.countPartial':
    '{count, plural, one {1 elemento cargado} other {{count} elementos cargados}} · hay más',
  'trash.restored': 'Archivo restaurado',
  'trash.deletedForever': 'Borrado definitivamente',
  'trash.deleteFailed': 'No se pudo borrar el archivo',
  'trash.purges': 'Se borra el {date}',
  'shares.deleteTitle': '¿Eliminar este enlace?',
  'shares.deleteBody': 'Quien tenga la URL dejará de poder abrirla. El archivo no se toca.',
  'shares.deleted': 'Enlace eliminado',
  'shares.disabled': 'Enlace desactivado',
  'shares.linkCreated': 'Enlace creado',
  'shares.createFailed': 'No se pudo crear el enlace',
  'shares.expNever': 'Nunca',
  'shares.exp1Day': '1 día',
  'shares.exp7Days': '7 días',
  'shares.exp30Days': '30 días',
  'shares.exp90Days': '90 días',
  'shares.unlimited': 'Sin límite',
  'preview.cannotPreview':
    'Este formato no se puede previsualizar en el navegador. Descárgalo para abrirlo con la aplicación adecuada.',
  'preview.unknownType': 'Tipo desconocido',
  'admin.title': 'Panel de plataforma',
  'admin.overview': 'Resumen',
  'admin.plans': 'Planes',
  'admin.plansBody':
    'El catálogo tal y como está en la base de datos: lo mismo que ve un cliente en la página de precios.',
  'admin.plansCatalog': 'Planes activos',
  'admin.plansPrice': 'Precio',
  'admin.plansSpaces': 'Espacios',
  'admin.plansFree': 'Gratis',
  'admin.plansReadOnly':
    'Sólo lectura. Cambiar un plan afecta a la vez a todos los clientes que lo tienen, así que se hace por SQL sobre «plans» y «plan_features».',
  'admin.badge': 'Plataforma',
  'admin.exitToMySpace': 'Volver a mi espacio',
  'admin.notOperator':
    'Esta cuenta no es operadora de la plataforma. El permiso se concede en base de datos.',
  'admin.pending':
    '{count, plural, =0 {sin solicitudes pendientes} one {1 solicitud por atender} other {{count} solicitudes por atender}}',
  'admin.environment': 'Entorno {name}',
  'admin.users': 'Usuarios',
  'admin.workspaces': 'Espacios',
  'admin.organizations': 'Organizaciones',
  'admin.storage': 'Almacenamiento',
  'admin.margins': 'Márgenes',
  'admin.marginsBody':
    'Qué cuesta servir a cada cliente frente a lo que paga. Primero los que ya cuestan más.',
  'admin.marginsEmpty': 'Ningún cliente se acerca a su punto de equilibrio.',
  'admin.marginsLosing': 'Cuestan más de lo que pagan',
  'admin.marginsLoss': 'Se pierde al mes',
  'admin.marginsWatch': 'Cerca del límite',
  'admin.marginsPays': 'Paga',
  'admin.marginsCosts': 'Cuesta',
  'admin.marginsMargin': 'Margen',
  'admin.marginsUsed': 'Cuota usada',
  'admin.marginsBreakeven': 'Equilibrio',
  'admin.marginsHint':
    'El coste sale de los bytes guardados a {price} $ por GB-mes, no de la cuota vendida: R2 cobra por lo que hay.',
  'admin.marginsTrend': 'Pendiente del consumo',
  'admin.marginsTrendBody':
    'Qué parte de la capacidad vendida está ocupada de verdad, día a día. Es lo que enseña si la utilización sube.',
  'admin.marginsTrendEmpty':
    'Todavía no hay histórico. Se guarda una foto cada noche; la pendiente aparece con la segunda.',
  'admin.marginsTrendDelta': '{delta} en {days} días',
  'admin.marginsTrendToday': 'Ocupado hoy',
  'admin.marginsTrendMargin': 'Margen del día',
  'admin.filesCount': 'Archivos',
  'admin.byPlan': 'Clientes por plan',
  'admin.requestsOpen': 'Sin resolver',
  'admin.planRequests': 'Solicitudes de plan',
  'admin.refresh': 'Actualizar',
  'admin.noRequests': 'No hay solicitudes pendientes.',
  'admin.loadFailed': 'No se pudo cargar el panel',
  'admin.actionFailed': 'No se pudo completar la acción',
  'planRequest.inProgress': 'solicitud en curso',
  'planRequest.requested':
    'Recibimos tu solicitud. Te enviaremos el link de pago en cuanto la revisemos; verás el aviso aquí mismo.',
  'planRequest.awaiting': 'Paga por {method} y avísanos para que lo comprobemos.',
  'planRequest.goToPayment': 'Ir al pago',
  'planRequest.reference': 'Referencia del pago (opcional)',
  'planRequest.referenceHint': 'Nº de operación o transferencia',
  'planRequest.declarePaid': 'Ya pagué',
  'planRequest.amount': 'A pagar',
  'planRequest.term': 'Plazo',
  'planRequest.perMonth': '{amount} al mes',
  'planRequest.savings': 'Ahorras {amount}',
  'planRequest.goToPaymentAmount': 'Ir al pago de {amount}',
  'planRequest.checking':
    'Gracias. Estamos comprobando el pago; en cuanto lo confirmemos, tu plan se activa solo y te avisamos.',
  'privacy.title': 'Privacidad',
  'privacy.exportTitle': 'Exportar mis datos',
  'privacy.exportBody':
    'Descarga una copia de tu perfil, tus espacios, el inventario de tus archivos, tus enlaces y tu actividad. El contenido de cada archivo se descarga desde la aplicación.',
  'privacy.exportAction': 'Descargar mis datos',
  'privacy.exportDone': 'Descarga preparada',
  'privacy.deleteTitle': 'Borrar mi cuenta',
  'privacy.deleteBody':
    'Se borran tus archivos y tus datos personales. Los registros de cobro se conservan sin vínculo contigo, por obligación contable.',
  'privacy.deleteAction': 'Solicitar la baja',
  'privacy.deleteConfirmTitle': '¿Borrar tu cuenta?',
  'privacy.deleteConfirmBody':
    'Tienes {days, plural, one {1 día} other {{days} días}} para cambiar de opinión: durante ese plazo la cuenta sigue funcionando y puedes cancelar desde aquí. Después, tus archivos se borran y no se pueden recuperar.',
  'privacy.deleteConfirm': 'Sí, borrar mi cuenta',
  'privacy.pendingTitle': 'Baja programada',
  'privacy.pendingBody':
    'Tu cuenta y tus archivos se borrarán el {date}. Hasta entonces todo sigue funcionando.',
  'privacy.cancelDeletion': 'Cancelar la baja',
  'privacy.cancelled': 'Baja cancelada',
  'privacy.requested': 'Baja programada',
  'notifications.markAllRead': 'Marcar todas como leídas',
  'notifications.empty': 'No tienes notificaciones.',
  'notifications.new': 'Nueva',
  'notifications.unreadCount': '{count, plural, one {1 sin leer} other {{count} sin leer}}',
  'workspace.switch': 'Cambiar de espacio',
  'workspace.active': 'Activo',
  'workspace.new': 'Nuevo espacio',
  'workspace.exploreBusiness': 'Descubrir Business',
  'upload.announceProgress': '{name}, {percent} %',
  'upload.announceCompleted': '{name} se subió correctamente',
  'upload.announceFailed': 'Error al subir {name}',
  'mfa.title': 'Verificación en dos pasos',
  'mfa.intro':
    'Añade un código de un solo uso a tu contraseña. Si alguien la consigue, seguirá sin poder entrar.',
  'mfa.statusOn': 'Activada',
  'mfa.statusOff': 'Desactivada',
  'mfa.enable': 'Activar',
  'mfa.disable': 'Desactivar',
  'mfa.step1': 'Escanea este código con tu aplicación de autenticación',
  'mfa.step1Help':
    'Sirve cualquiera: Google Authenticator, Authy, 1Password, Microsoft Authenticator.',
  'mfa.qrLabel': 'Código QR para configurar la verificación en dos pasos',
  'mfa.manualEntry': '¿No puedes escanear? Escribe esta clave a mano:',
  'mfa.step2': 'Escribe el código de seis dígitos que muestra la aplicación',
  'mfa.code': 'Código',
  'mfa.codePlaceholder': '000000',
  'mfa.confirm': 'Confirmar y activar',
  'mfa.cancel': 'Cancelar',
  'mfa.enabled': 'Verificación en dos pasos activada',
  'mfa.disabled': 'Verificación en dos pasos desactivada',
  'mfa.recoveryTitle': 'Guarda estos códigos de recuperación',
  'mfa.recoveryBody':
    'Cada uno sirve una vez para entrar si pierdes el móvil. **No se pueden volver a mostrar**: guardamos sólo su huella, igual que con las contraseñas. Cópialos ahora.',
  'mfa.recoveryDone': 'Los he guardado',
  'mfa.recoveryRemaining':
    '{count, plural, =0 {No te quedan códigos de recuperación} one {Te queda 1 código de recuperación} other {Te quedan {count} códigos de recuperación}}',
  'mfa.regenerate': 'Generar códigos nuevos',
  'mfa.regenerateHelp': 'Los anteriores dejarán de servir.',
  'mfa.disableTitle': 'Desactivar la verificación en dos pasos',
  'mfa.disableBody':
    'Pedimos la contraseña y un código: con la sesión sola, quien te la robara podría quitar justo la protección que se lo impide.',
  'mfa.password': 'Tu contraseña',
  'mfa.challengeTitle': 'Verificación en dos pasos',
  'mfa.challengeBody': 'Escribe el código de tu aplicación de autenticación.',
  'mfa.challengeRecovery': 'También puedes usar uno de tus códigos de recuperación.',
  'mfa.verify': 'Verificar',
  'mfa.copySecret': 'Copiar clave',
  'mfa.copied': 'Copiado',
  'password.problems': 'Elige otra contraseña:',
  'password.TOO_SHORT': 'Debe tener al menos 10 caracteres.',
  'password.TOO_LONG': 'Es demasiado larga.',
  'password.MISSING_LETTER': 'Debe incluir alguna letra.',
  'password.MISSING_DIGIT': 'Debe incluir algún número, o tener al menos 16 caracteres.',
  'password.COMMON': 'Es una de las contraseñas más usadas del mundo.',
  'password.SEQUENTIAL': 'Contiene una secuencia previsible, como «1234» o «abcd».',
  'password.KEYBOARD_PATTERN': 'Contiene un recorrido del teclado, como «qwerty».',
  'password.REPEATED': 'Repite el mismo trozo una y otra vez.',
  'password.LOW_VARIETY': 'Usa muy pocos caracteres distintos.',
  'password.CONTAINS_EMAIL': 'Contiene tu correo.',
  'password.CONTAINS_NAME': 'Contiene tu nombre.',
  'password.CONTAINS_APP_NAME': 'Contiene el nombre del servicio.',

  'team.title': 'Equipo',
  'team.subtitle': 'Quién puede entrar y qué puede hacer.',
  'team.invite': 'Invitar',
  'team.inviteTitle': 'Invitar a alguien',
  'team.inviteBody':
    'Si ya tiene cuenta recibirá un aviso y decidirá si entra. Si no la tiene, podrás crearla.',
  'team.email': 'Correo de la persona',
  'team.firstName': 'Nombre (opcional)',
  'team.lastName': 'Apellidos (opcional)',
  'team.createAccountTitle': 'Ese correo no tiene cuenta',
  'team.createAccountBody': 'Nadie ha usado {email} para registrarse en 29100 Cloud.',
  'team.createAccountHelp':
    'Puedes abrirle la cuenta ahora y añadirla al equipo. Te daremos una contraseña temporal para que se la entregues; el correo no se comprueba, así que revísalo antes.',
  'team.createAccount': 'Crear la cuenta',
  'team.accountCreated': 'Cuenta creada',
  'team.accountCreatedBody': 'Ya forma parte del equipo. Entrega estos datos a {email}.',
  'team.accountAdded': 'Cuenta creada y añadida al equipo',
  'team.temporaryPassword': 'Contraseña temporal',
  'team.temporaryPasswordOnce':
    'Cópiala ahora: no se guarda en ninguna parte y no volverá a mostrarse. Si la pierdes, esa persona puede recuperarla desde «He olvidado mi contraseña». Conviene que la cambie al entrar.',
  'team.role': 'Rol',
  'team.invited': 'Invitación enviada',
  'team.pending': 'Pendiente de aceptar',
  'team.member': 'Miembro',
  'team.you': 'Tú',
  'team.changeRole': 'Cambiar rol',
  'team.remove': 'Quitar del equipo',
  'team.removeTitle': '¿Quitar a {name} del equipo?',
  'team.removeBody': 'Perderá el acceso a la organización de inmediato. Puedes volver a invitarle.',
  'team.removed': 'Se quitó del equipo',
  'team.roleChanged': 'Rol actualizado',
  'team.empty': 'Todavía estás tú solo.',
  'team.emptyBody': 'Invita a tu equipo para trabajar sobre las mismas carpetas.',
  'team.count': '{count, plural, one {1 persona} other {{count} personas}}',
  'team.seats': '{used} de {limit} plazas del plan {plan}',
  'team.seatsFull': 'No quedan plazas',
  'team.seatsFullBody':
    'Tu plan {plan} admite {limit, plural, one {1 persona} other {{limit} personas}} y ya están ocupadas. Amplía el plan para seguir sumando gente al equipo.',
  'team.seatsUpgrade': 'Ampliar el plan',
  'team.noOrganization': 'Esta sección es de 29100 Cloud Business.',
  'team.noOrganizationBody': 'Cambia a un espacio de organización o crea uno.',
  'role.OWNER': 'Propietario',
  'role.ADMIN': 'Administrador',
  'role.MEMBER': 'Miembro',
  'role.VIEWER': 'Sólo lectura',
  'role.OWNER.help': 'Control total, incluida la facturación.',
  'role.ADMIN.help': 'Gestiona personas, carpetas y permisos.',
  'role.MEMBER.help': 'Sube, edita y comparte donde tenga acceso.',
  'role.VIEWER.help': 'Sólo puede leer y descargar.',
  'invitation.title': 'Te han invitado',
  'invitation.body': '{who} te invitó a {organization} como {role}.',
  'invitation.bodyNoOne': 'Te invitaron a {organization} como {role}.',
  'invitation.accept': 'Entrar',
  'invitation.decline': 'Rechazar',
  'invitation.accepted': 'Ya formas parte de {organization}',
  'invitation.declined': 'Invitación rechazada',

  'admin.organizationsBody': 'Todas las empresas de la plataforma, su plan y su consumo.',
  'admin.members': 'Personas',
  'admin.pendingInvites': '{count, plural, =0 {} one {1 pendiente} other {{count} pendientes}}',
  'admin.owner': 'Responsable',
  'admin.orgState': 'Estado',
  'admin.orgSpaces': 'Espacios',
  'admin.orgActive': 'Activa',
  'admin.orgSuspended': 'Suspendida',
  'admin.orgDeletedState': 'Marcada como borrada',
  'admin.orgOrphan': 'Sin espacio',
  'admin.orgOrphanHint':
    'No tiene ningún espacio: no se puede abrir ni consume nada. Suele ser el resto de un alta que no terminó.',
  'admin.orgDeleting': 'Se borra el {date}',
  'admin.orgOwnerMismatch': 'El propietario del espacio es {email}',
  'admin.orgOwnerMismatchHint':
    'La organización y su espacio tienen responsables distintos. Al crearla son la misma persona, así que esto viene de un cambio hecho en la base de datos.',
  'admin.orgOpen': 'Ver cliente',
  'admin.storageBody': 'Cuánto se guarda, bajo qué plan y quién consume más.',
  'admin.topPersonal': 'Cuentas personales que más consumen',
  'admin.topBusiness': 'Empresas que más consumen',
  'admin.spaces': 'Espacios',
  'admin.files': 'Archivos',
  'admin.audit': 'Auditoría',
  'admin.auditBody': 'Todo lo que ha ocurrido en la plataforma, con quién y cuándo.',
  'admin.action': 'Acción',
  'admin.actor': 'Quién',
  'admin.when': 'Cuándo',
  'admin.resource': 'Sobre qué',
  'admin.allActions': 'Todas las acciones',
  'admin.anonymized': 'Cuenta dada de baja',
  'admin.auditEmpty': 'No hay registros con ese filtro.',
  'admin.more': 'Ver más',
  'admin.plansPending':
    'La edición de planes se hace por SQL, con cabeza: un plan mal tocado afecta a todos los clientes que lo tienen.',

  'sharing.title': 'Quién tiene acceso',
  'sharing.restricted': 'Acceso restringido',
  'sharing.open': 'La ve todo el equipo',
  'sharing.openBody': 'Cualquier persona de la organización puede entrar en esta carpeta.',
  'sharing.restrictedBody':
    'Sólo entran las personas de la lista. El resto del equipo no la ve ni sabe que existe.',
  'sharing.share': 'Dar acceso',
  'sharing.shareTitle': 'Dar acceso a esta carpeta',
  'sharing.shareBody':
    'Al dar acceso a alguien, la carpeta deja de verla el resto del equipo. Tiene que ser una persona del equipo.',
  'sharing.email': 'Correo de la persona',
  'sharing.permissions': 'Qué puede hacer',
  'sharing.granted': 'Acceso concedido',
  'sharing.revoke': 'Quitar acceso',
  'sharing.revoked': 'Acceso retirado',
  'sharing.openUp': 'Volver a abrirla a todo el equipo',
  'sharing.openUpTitle': '¿Abrir la carpeta a todo el equipo?',
  'sharing.openUpBody':
    'Volverá a verla cualquier persona de la organización y se retirarán los accesos concedidos.',
  'sharing.opened': 'La carpeta vuelve a ser de todo el equipo',
  'sharing.nobody': 'Todavía no le has dado acceso a nadie.',
  'sharing.you': 'Tú, por administrar la organización',
  'perm.VIEW': 'Ver',
  'perm.DOWNLOAD': 'Descargar',
  'perm.UPLOAD': 'Subir',
  'perm.CREATE_FOLDER': 'Crear carpetas',
  'perm.EDIT': 'Editar',
  'perm.DELETE': 'Eliminar',
  'perm.SHARE': 'Compartir',
  'sharedFolders.title': 'Carpetas compartidas',
  'sharedFolders.subtitle': 'Carpetas del equipo a las que te han dado acceso.',
  'sharedFolders.empty': 'Nadie te ha dado acceso a ninguna carpeta.',
  'sharedFolders.emptyBody': 'Cuando alguien restrinja una carpeta y te incluya, aparecerá aquí.',
  'sharedFolders.open': 'Abrir',

  'subscription.canceling': 'Cancelándose',
  'subscription.paidUntil': 'Pagado hasta',
  'subscription.paidOn': 'Fecha de pago',
  'subscription.term': 'Plazo contratado',
  'subscription.trial': 'En prueba',
  'subscription.trialUntil': 'Prueba hasta',
  'subscription.daysLeft': '{count, plural, one {queda 1 día} other {quedan {count} días}}',
  'subscription.expiredAlready': 'vencido',
  'subscription.renewalPolicy':
    'Si no se renueva, la suscripción caduca el {date}. A partir de ahí el espacio queda en sólo lectura a los {suspend} días y se borra a los {remove}. Te avisamos antes de cada paso.',
  'subscription.renew': 'Renovar plan',
  'subscription.expiringTitle': 'Tu plan vence pronto',
  'subscription.expiringBody':
    'Tu plan vence el {date}: {days, plural, one {queda 1 día} other {quedan {days} días}}. Renuévalo y no se interrumpe nada.',
  'subscription.lapsedTitle': 'Tu plan ha vencido',
  'subscription.lapsedBody':
    'Todavía no cambia nada. Si el pago no entra antes del {date}, el espacio pasa a estar en mora y a los {days} días queda en sólo lectura.',
  'subscription.unpaidTitle': 'Tu espacio está pendiente de pago',
  'subscription.unpaidGrace':
    'Aún funciona todo. Si el pago no entra, el {suspend} el espacio queda en sólo lectura, el {block} pierdes el acceso y el {delete} se borra definitivamente.',
  'subscription.unpaidSuspended':
    'El espacio está en sólo lectura: puedes entrar, consultar y descargar, pero no subir. El {block} pierdes el acceso y el {delete} se borra definitivamente. Descarga lo que necesites antes del {block}.',
  'subscription.unpaidBlocked':
    'El espacio está bloqueado y se borrará definitivamente el {delete}. Para recuperarlo hay que pagar antes de esa fecha: después no hay copia que restaurar.',
  'subscription.unpaidStepSuspend': 'Sólo lectura',
  'subscription.unpaidStepBlock': 'Sin acceso',
  'subscription.unpaidStepDelete': 'Borrado definitivo',
  'subscription.unpaidIrreversible': 'no se puede deshacer',
  'receipts.title': 'Mis comprobantes',
  'receipts.body':
    'Lo que has contratado y lo que has pagado. Cada línea dice qué periodo cubre y con qué referencia entró el pago.',
  'receipts.empty': 'Todavía no hay comprobantes. Aparecen al activarse un plan de pago.',
  'receipts.number': 'Nº',
  'receipts.plan': 'Plan',
  'receipts.period': 'Periodo',
  'receipts.term': 'Plazo',
  'receipts.amount': 'Importe',
  'receipts.method': 'Medio',
  'receipts.reference': 'Referencia',
  'receipts.paid': 'Cobrado',
  'receipts.unpaid': 'Pendiente',
  'receipts.freeMonths': '{count, plural, one {1 mes gratis} other {{count} meses gratis}}',
  'receipts.months': '{count, plural, one {1 mes} other {{count} meses}}',
  'admin.receipts': 'Cobros',
  'admin.receiptsBody':
    'Todo lo facturado y cobrado, con quién dio cada ingreso por bueno. Es lo que se mira para cerrar una reclamación.',
  'admin.receiptsEmpty': 'Todavía no se ha cobrado nada.',
  'admin.receiptsCollected': 'Cobrado en {days} días',
  'admin.receiptsCount': 'Comprobantes emitidos',
  'admin.receiptsRecordedBy': 'Confirmó',
  'subscription.cancelTitle': 'Cancelar la suscripción',
  'subscription.cancelBody':
    'Conservas todo hasta el final del periodo que ya has pagado. Después el espacio vuelve al plan gratuito y, si tus archivos ya no caben, tienes {days} días para liberar espacio antes de que llevemos el exceso a la papelera.',
  'subscription.cancelAction': 'Cancelar la suscripción',
  'subscription.confirmTitle': '¿Cancelar tu suscripción?',
  'subscription.confirmBody':
    'Tu plan sigue activo hasta el {date}. Después el espacio vuelve al plan gratuito y, si tus archivos ya no caben, tienes {days} días para liberar espacio. Puedes deshacerlo en cualquier momento antes del {date}.',
  'subscription.canceled': 'Cancelada. Tu plan sigue activo hasta el final del periodo.',
  'subscription.pendingTitle': 'Cancelación programada',
  'subscription.pendingBody':
    'Tu plan sigue activo hasta el {date}. Hasta entonces no cambia nada, y todavía puedes deshacerlo.',
  'subscription.pendingBodyNoDate':
    'Tu plan volverá al gratuito cuando termine el periodo en curso.',
  'subscription.reactivate': 'Seguir con mi suscripción',
  'subscription.back': 'Cancelación deshecha. Tu suscripción continúa.',
  'subscription.overQuotaTitle': 'Tus archivos ya no caben en tu plan',
  'subscription.overQuotaBody':
    'Puedes leerlo y descargarlo todo, pero no subir. Tienes {days} días: el {date} moveremos los archivos más grandes a la papelera hasta volver al límite. Nada se borra de verdad — la papelera mantiene su propia retención.',
  'subscription.overQuotaFree': 'Liberar espacio',

  'reports.title': 'Informes',
  'reports.subtitle': 'Qué guarda tu equipo, cómo crece y qué hace.',
  'reports.restricted': 'Sólo para propietarios y administradores',
  'reports.restrictedBody':
    'Estos informes dicen cuánto guarda cada persona. Eso es información sobre tus compañeros, así que se queda en manos de quien dirige la organización.',
  'reports.totalStored': 'Guardado por el equipo',
  'reports.totalFiles': 'Archivos',
  'reports.byMember': 'Quién guarda cuánto',
  'reports.byMemberBody': 'Lo que está en la papelera no se le atribuye a nadie.',
  'reports.empty': 'Todavía no hay nada guardado.',
  'reports.formerMember': 'Cuenta que ya no está activa',
  'reports.exportCsv': 'Exportar CSV',
  'reports.growth': 'Evolución',
  'reports.growthBody': 'Cuánto entró cada mes, y el acumulado.',
  'reports.growthCaveat':
    'Es la fecha de subida de lo que hoy existe, no una foto histórica: lo que se borró no aparece. Responde a cuándo hará falta un plan mayor, que es para lo que sirve.',
  'reports.range': 'Periodo',
  'reports.months': '{count} meses',
  'reports.month': 'Mes',
  'reports.added': 'Entró',
  'reports.cumulative': 'Acumulado',
  'reports.activity': 'Actividad del equipo',
  'reports.activityBody': 'Qué se ha subido, compartido y borrado.',
  'reports.noActivity': 'No hay actividad registrada.',

  'tenants.title': 'Clientes',
  'tenants.subtitle': 'Quién paga, cuánto consume, quién se va.',
  'tenants.mrr': 'Ingreso mensual',
  'tenants.paid': 'En plan de pago',
  'tenants.canceling': 'Cancelándose',
  'tenants.suspendedCount': 'Suspendidos',
  'tenants.search': 'Espacio o correo del propietario',
  'tenants.state': 'Estado',
  'tenants.stateAll': 'Todos',
  'tenants.state_paid': 'De pago',
  'tenants.state_free': 'Gratuito',
  'tenants.state_canceling': 'Cancelándose',
  'tenants.state_over_quota': 'Sobre la cuota',
  'tenants.state_suspended': 'Suspendido',
  'tenants.state_unpaid': 'Impagado',
  'tenants.expiringCount': 'Vencen pronto',
  'tenants.expiringHint': 'Hay que cobrarles antes de que venzan.',
  'tenants.unpaidCount': 'Impagados',
  'tenants.unpaidHint': 'Con el plazo corriendo hacia el borrado.',
  'tenants.paidUntil': 'Pagado hasta',
  'tenants.periodStart': 'Inicio del periodo',
  'tenants.billing': 'Facturación',
  'tenants.billingHint':
    'Precio de catálogo: {amount} al mes. Lo cobrado de verdad, con el descuento por plazo aplicado, está en cada comprobante.',
  'tenants.unpaidTitle': 'Este cliente dejó de pagar',
  'tenants.unpaidBody':
    'El plazo cuenta desde el {date}. Asignarle un plan de pago lo cierra y levanta la suspensión en el acto.',
  'tenants.unpaidHintDetail':
    'Faltan {days, plural, =0 {menos de un día} one {1 día} other {{days} días}} para el borrado definitivo. Después no hay copia que restaurar.',
  'tenants.sort': 'Ordenar por',
  'tenants.sortRecent': 'Más reciente',
  'tenants.sortStorage': 'Almacenamiento',
  'tenants.sortName': 'Nombre',
  'tenants.apply': 'Aplicar',
  'tenants.empty': 'Ningún cliente coincide.',
  'tenants.showing': 'Mostrando {shown} de {total}.',
  'tenants.tenant': 'Espacio',
  'tenants.plan': 'Plan',
  'tenants.usage': 'Almacenamiento',
  'tenants.people': 'Personas',
  'tenants.overQuota': 'Sobre la cuota',
  'tenants.suspended': 'Suspendido',
  'tenants.suspend': 'Suspender',
  'tenants.reactivate': 'Reactivar',
  'tenants.reactivated': 'El espacio vuelve a estar activo.',
  'tenants.suspendedTitle': 'Este espacio está en sólo lectura',
  'tenants.suspendedBody': 'Suspendido el {date}. Puede seguir entrando y descargando.',
  'tenants.suspendBody':
    'Sigue pudiendo leer y descargar: cortarle a alguien el acceso a sus propios archivos por una factura convierte una disputa comercial en una reclamación de protección de datos. Lo que pierde es subir, editar, borrar y compartir.',
  'tenants.reason': 'Motivo',
  'tenants.reasonHint': 'Quien atienda la llamada no será quien lo suspendió.',
  'tenants.changePlan': 'Cambiar de plan',
  'tenants.recalculate': 'Recalcular consumo',
  'tenants.recalculated': 'Consumo recalculado sobre los archivos reales',
  'tenants.changePlanBody':
    'Aplica el plan directamente, sin solicitud. Para un pago que llegó por otra vía o para corregir un error — queda registrado con tu nombre.',
  'tenants.months': 'Meses',
  'tenants.planChanged': 'Plan actualizado.',
  'tenants.chargeLabel': 'A cobrar',
  'tenants.listWas': 'antes {amount}',
  'tenants.untilDate': 'hasta el {date}',
  'tenants.adjustPeriod': 'Ajustar vigencia',
  'tenants.adjustPeriodBody':
    'Mueve la fecha de fin sin tocar el plan ni el alta. Para alargar una prueba o aplicar un contrato negociado.',
  'tenants.currentEnd': 'Vigencia actual',
  'tenants.resultingEnd': 'Quedaría hasta',
  'tenants.days': 'días',
  'tenants.customDays': 'Otros días (negativo para acortar)',
  'tenants.untilExact': 'O hasta esta fecha exacta',
  'tenants.untilExactHint': 'Sustituye a los días. La vigencia termina al acabar ese día.',
  'tenants.periodReasonHint':
    'Obligatorio. Es lo que verá el cliente y lo que queda en la auditoría de quién concedió el tiempo.',
  'tenants.periodAdjusted': 'Vigencia actualizada.',
  'tenants.shorteningWarning':
    'Esta fecha ya pasó: el cliente entra en cuenta atrás hacia la suspensión y, si nadie paga, el borrado. Asegúrate de que es lo que quieres.',
  'tenants.trial': 'Prueba',
  'tenants.trialLabel': 'Conceder como prueba, sin cobro',
  'tenants.trialHint':
    'Mismas prestaciones que un plan pagado, pero no cuenta como cliente de pago ni suma al ingreso mensual.',
  'tenants.trialCount': 'En prueba',
  'tenants.trialHintCard': 'No suman al ingreso mensual.',
  'tenants.state_trial': 'En prueba',
  'tenants.state_expiring': 'Vencen pronto',
  'tenants.trialUntil': 'Prueba hasta el {date}',
  'tenants.since': 'Cliente desde {date}',
  'tenants.createdHint': 'Datos a {date}.',
  'tenants.state_deleting': 'Con borrado programado',
  'tenants.deletingCount': 'Programados para borrar',
  'tenants.deletingHint': 'En cuenta atrás. Todavía se puede anular.',
  'tenants.delete': 'Borrar cliente',
  'tenants.deleteTitle': '¿Borrar «{name}»?',
  'tenants.deleteBodyEmpty':
    'Este espacio no tiene ningún archivo. Se borrará del todo en {days} días, y si alguien vuelve a entrar antes, el borrado se anula solo.',
  'tenants.deleteBodyData':
    'Este espacio tiene {files, plural, one {# archivo} other {# archivos}} ({size}). Queda en sólo lectura —el cliente puede descargarlo todo— y se borrará del todo en {days} días. Después no hay vuelta atrás.',
  'tenants.deleteReasonHint':
    'Obligatorio cuando hay archivos. Es lo que verá el cliente y lo que queda en la auditoría cuando ya no exista el espacio.',
  'tenants.deleteConfirm': 'Programar borrado',
  'tenants.deleteScheduled': 'Borrado programado para el {date}.',
  'tenants.deletionTitle': 'Este espacio está programado para borrarse',
  'tenants.deletionBody':
    'Se borrará del todo el {date}, dentro de {days, plural, one {# día} other {# días}}.',
  'tenants.deletionEmptyHint':
    'Estaba vacío al programarlo: si alguien inicia sesión antes de esa fecha, el borrado se anula solo.',
  'tenants.deletionDataHint':
    'Mientras tanto queda en sólo lectura, para que el cliente pueda descargar lo suyo hasta el último día.',
  'tenants.deletionRequestedBy': 'Lo pidió {email} el {date}.',
  'tenants.cancelDeletion': 'Anular borrado',
  'tenants.deletionCanceled': 'Borrado anulado. El espacio sigue en pie.',
  'tenants.deletingBadge': 'Se borra el {date}',

  'albums.title': 'Álbumes',
  'albums.subtitle': 'Colecciones de fotos. Una foto puede estar en varias sin copiarse.',
  'albums.new': 'Nuevo álbum',
  'albums.name': 'Nombre del álbum',
  'albums.empty': 'Todavía no hay álbumes.',
  'albums.emptyBody': 'Elige fotos en la galería y crea un álbum con ellas.',
  'albums.emptyAlbum': 'Este álbum está vacío.',
  'albums.emptyAlbumBody': 'Sube fotos o vídeos aquí, o añade lo que ya tienes en la galería.',
  'albums.photoCount': '{count, plural, one {# elemento} other {# elementos}}',
  'albums.createFrom': 'Crear álbum',
  'albums.createBody': 'Entrarán {count, plural, one {# elemento} other {# elementos}}.',
  'albums.created': 'Álbum creado con {count, plural, one {# elemento} other {# elementos}}.',
  'albums.createdEmpty': 'Álbum creado.',
  'albums.renamed': 'Álbum renombrado.',
  'albums.deleted': 'Álbum eliminado. Tus fotos siguen ahí.',
  'albums.deleteTitle': '¿Eliminar «{name}»?',
  'albums.deleteBody':
    'Desaparece el álbum, no las fotos. Deshacer una colección no deshace lo coleccionado.',
  'albums.removeFrom': 'Quitar del álbum',
  'albums.removed': '{count, plural, one {# elemento} other {# elementos}} fuera del álbum.',
  'albums.addPhotos': 'Añadir fotos',
  'albums.addFromGallery': 'Añadir de la galería',
  'albums.addFromGalleryBody': 'Sólo sale lo que aún no está en este álbum.',
  /* Distinto de «Seleccionar …» de la galería: aquí seleccionar es añadir, y
     las dos cuadrículas están en la misma pantalla. */
  'albums.selectToAdd': 'Añadir {name}',
  'albums.addSelected': 'Añadir {count, plural, one {# elemento} other {# elementos}}',
  'albums.alreadyIn': 'Ya estaban en el álbum.',
  'albums.added': '{count, plural, one {# elemento} other {# elementos}} en el álbum.',
  'albums.uploaded':
    '{count, plural, one {# elemento subido y añadido} other {# elementos subidos y añadidos}} al álbum.',
  'albums.allPhotosIn': 'Todo lo que tienes ya está en este álbum.',
  'albums.noPhotosYet': 'Todavía no tienes fotos ni vídeos.',
  'albums.noPhotosYetBody': 'Súbelas desde el álbum y entrarán en él directamente.',
  'albums.addTo': 'Añadir a un álbum',
  'albums.addToBody': 'Entrarán {count, plural, one {# elemento} other {# elementos}} en el álbum.',
  'albums.pick': 'Álbum',
  'shares.shareAlbum': 'Compartir álbum',
  'photos.deleteConfirm': '¿Eliminar {count, plural, one {# elemento} other {# elementos}}?',
  'photos.deleteConfirmBody': 'Van a la papelera, donde todavía puedes recuperarlos.',
  'settings.avatarChange': 'Cambiar foto',
  'settings.avatarRemove': 'Quitar foto',
  'settings.avatarHint': 'JPG, PNG, WebP o GIF, hasta 2 MB.',
  'settings.avatarUpdated': 'Foto de perfil actualizada.',
  'settings.avatarRemoved': 'Foto de perfil quitada.',
  'publicShare.albumTitle': 'Álbum compartido',
  'publicShare.albumCount': '{count, plural, one {# foto} other {# fotos}}',

  'checklists.title': 'Listas de verificación',
  'checklists.subtitle':
    'Qué documentos hacen falta para cada trámite. Al usar una sugerida se copia, y desde ese momento es tuya.',
  'checklists.new': 'Nueva lista',
  'checklists.name': 'Nombre de la lista',
  'checklists.mine': 'Mis listas',
  'checklists.suggested': 'Sugeridas para tu profesión',
  'checklists.suggestedBody':
    'Salen del uso que elegiste para este espacio. Puedes cambiarlas después.',
  'checklists.useTemplate': 'Usar esta lista',
  'checklists.alreadyUsed': 'Ya la usaste',
  'checklists.itemCount': '{count, plural, one {# casilla} other {# casillas}}',
  'checklists.empty': 'Todavía no tienes ninguna lista.',
  'checklists.emptyBody': 'Empieza por una sugerida, o crea la tuya desde cero.',
  'checklists.noItems': 'Esta lista todavía no tiene casillas.',
  'checklists.created': 'Lista creada.',
  'checklists.renamed': 'Lista renombrada.',
  'checklists.deleted': 'Lista eliminada.',
  'checklists.deleteTitle': '¿Eliminar «{name}»?',
  'checklists.deleteBody':
    'Desaparece la lista y sus casillas. Tus archivos y carpetas no se tocan.',
  'checklists.copyNotice':
    'Esta lista es una copia tuya: edítala como quieras. La plantilla original no cambia.',
  'checklists.addItem': 'Añadir una casilla',
  'checklists.itemLabel': 'Nombre de la casilla',
  'checklists.itemRemoved': 'Casilla eliminada.',
  'checklists.itemRenamed': 'Casilla renombrada.',
  'checklists.optional': 'opcional',
  'checklists.markOptional': 'Marcar como opcional',
  'checklists.markRequired': 'Marcar como obligatoria',
  'checklists.moveUp': 'Subir «{label}»',
  'checklists.moveDown': 'Bajar «{label}»',

  'requests.title': 'Solicitudes de documentos',
  'requests.subtitle':
    'Pide una lista de documentos y comparte un enlace. Quien lo recibe sube cada uno sin necesitar cuenta.',
  'requests.new': 'Nueva solicitud',
  'requests.empty': 'Todavía no has pedido ningún documento.',
  'requests.emptyBody':
    'Elige una lista de verificación, di en qué carpeta caen los documentos y comparte el enlace.',
  'requests.progress': '{done} de {total} entregados',
  'requests.progressLabel': 'Avance de «{title}»',
  'requests.usedOfMax': '{used} de {max}',
  'requests.expiresOn': 'hasta el {date}',
  'requests.pending': 'Pendiente de entrega',
  'requests.view': 'Ver',
  'requests.openFolder': 'Abrir la carpeta',
  'requests.inTrash': 'En la papelera',
  'requests.status.open': 'Abierta',
  'requests.status.completed': 'Completada',
  'requests.status.closed': 'Cerrada',
  'requests.status.expired': 'Caducada',
  'requests.folder': 'Carpeta donde caen los documentos',
  'requests.folderHint': 'Los archivos entregados aparecerán aquí, como cualquier otro.',
  'requests.folderPick': 'Elige una carpeta…',
  'requests.checklist': 'Lista de verificación',
  'requests.checklistHint': 'De aquí salen los documentos que se piden.',
  'requests.checklistPick': 'Elige una lista…',
  'requests.titleField': 'Título',
  'requests.titleHint': 'Si lo dejas vacío, se usa el nombre de la lista.',
  'requests.recipient': 'Para quién es',
  'requests.recipientHint': 'Sólo lo ves tú: sirve para distinguir varias solicitudes iguales.',
  'requests.message': 'Mensaje para quien lo recibe',
  'requests.newLink': 'Emitir un enlace nuevo',
  /*
   * Creada sin que nadie haya visto su enlace.
   *
   * Pasa cuando la creación se tuerce después de haber guardado la solicitud, o
   * cuando la respuesta se pierde por el camino: el token en claro iba ahí y no
   * se puede volver a sacar de la base, donde sólo vive su huella.
   */
  'requests.createdNoLink': 'La solicitud se creó',
  'requests.createdNoLinkBody':
    '«{title}» ya está en la lista, pero no pudimos enseñarte su enlace. Emite uno ahora para poder enviarlo.',
  'requests.issueLink': 'Emitir el enlace',
  'requests.planLimit':
    'Tu plan permite {limit, plural, one {# solicitud abierta} other {# solicitudes abiertas}} a la vez. Cierra una para crear otra, o cambia de plan.',
  'requests.linkTitle': 'El enlace de la solicitud',
  'requests.linkBody':
    'Cópialo ahora: no se puede volver a mostrar. Guardamos sólo su huella, así que si lo pierdes hay que emitir otro y el anterior deja de servir.',
  'requests.linkField': 'Enlace',
  'requests.linkCopied': 'Enlace copiado.',
  'requests.linkCopyFailed': 'No se pudo copiar. Selecciónalo y cópialo a mano.',
  'requests.close': 'Cerrar solicitud',
  'requests.closeTitle': '¿Cerrar «{title}»?',
  'requests.closeBody': 'El enlace dejará de aceptar documentos. Lo entregado se queda.',
  'requests.closed': 'Solicitud cerrada.',
  'requests.deleteTitle': '¿Eliminar «{title}»?',
  'requests.deleteBody':
    'Desaparece la solicitud, no los documentos: los que ya llegaron siguen en su carpeta.',
  'requests.deleted': 'Solicitud eliminada.',

  'apiError.UNAUTHORIZED': 'Necesitas iniciar sesión.',
  'apiError.SESSION_EXPIRED': 'Tu sesión ha caducado. Vuelve a entrar.',
  'apiError.FORBIDDEN': 'No tienes permiso para hacer esto.',
  'apiError.NOT_FOUND': 'No encontramos lo que buscas.',
  'apiError.EMAIL_NOT_REGISTERED':
    'Ese correo todavía no tiene cuenta en 29100 Cloud. Pídele que se registre y vuelve a invitarlo.',
  'apiError.MODULE_NOT_IN_WORKSPACE': 'Esta sección es de las cuentas de empresa.',
  'apiError.VALIDATION_ERROR': 'Revisa los datos introducidos.',
  'apiError.STORAGE_LIMIT_EXCEEDED': 'Tu espacio está lleno.',
  'apiError.PLAN_LIMIT_EXCEEDED': 'Has llegado al límite de tu plan para esto.',
  'apiError.FILE_TOO_LARGE': 'El archivo supera el tamaño máximo de tu plan.',
  'apiError.CSRF_TOKEN_INVALID': 'Tu sesión expiró. Recarga la página e inténtalo de nuevo.',
  'apiError.RATE_LIMITED': 'Demasiados intentos. Espera un momento.',
  'apiError.CONFLICT': 'Esa acción entra en conflicto con el estado actual.',
  'apiError.INVALID_CREDENTIALS': 'Correo o contraseña incorrectos.',
  'apiError.ACCOUNT_SUSPENDED': 'Tu cuenta está suspendida.',
  'apiError.NETWORK_ERROR':
    'No pudimos contactar con el servidor. Revisa tu conexión; si el problema sigue, avísanos.',
  'apiError.DATABASE_UNAVAILABLE':
    'El servicio no está disponible en este momento. Vuelve a intentarlo en unos minutos.',
  /* El almacenamiento, no el programa: se puede reintentar y no es culpa de
     quien sube. Va con el detalle que trae la API —el paso y el código con que
     R2 contestó— porque quien administra este servicio es quien lo usa, y sin
     eso el siguiente informe vuelve a ser «no me deja subir». */
  'apiError.STORAGE_UNAVAILABLE': 'El almacenamiento no aceptó la operación. Vuelve a intentarlo.',
  'apiError.INTERNAL_ERROR': 'Se produjo un error inesperado.',
} as const;

export type MessageKey = keyof typeof es;
